import React, {Component} from 'react';
import axios from "axios";
import Select from "react-select";
import Button from "react-bootstrap/Button";

import classes from'./PlatformsInput.module.css';
import NewPlatform from "../NewPlatform/NewPlatform";
import apiUrl from "../../../shared/config";

class PlatformsInput extends Component  {
    state = {
        platforms: [],
        selected_platforms: [],
        new_game_platform: false
    };

    componentDidMount() {
        if (this.state.platforms !== []) {
            axios.get(apiUrl +'Platforms/getPlatforms')
                .then(response => {
                    this.setState({platforms: response.data});
                });
        }
        this.setState({selected_platforms: this.props.gamePlatforms});
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps !== this.props) {
            this.setState({selected_platforms: this.props.gamePlatforms});
        }
    }

    addPlatform = () => {
        this.setState(
            {selected_platforms: [
                    ...this.state.selected_platforms,
                    {
                        game_platform_id: null
                    }]
            });
    };

    newGamePlatformToggle = () => {
        this.setState({new_game_platform: !this.state.new_game_platform});
    };

    newGamePlatformsHandler = (new_game_platform) => {
        this.setState({platforms: [new_game_platform, ...this.state.platforms]});
    };

    arraySearch(arr,val) {
        for (let i = 0; i < arr.length; i++) {
            if (arr[i].value === val)
                return i;
        }
        return -1;
    }

    render() {
        let platforms_input_element = null;
        if (this.state.platforms && this.state.platforms.length) {
            const platformsOptions = this.state.platforms
                .map( platform => ({value: platform.game_platform_id, label: platform.game_platform_name}));

            if (this.state.selected_platforms && this.state.selected_platforms.length) {
                let platforms_index = 0;
                let selected_platforms = [...this.state.selected_platforms];
                platforms_input_element = (
                    <>
                        <dd className="col-sm-9">
                            {selected_platforms.map(platform => {
                                let platforms_index_local = platforms_index;
                                const game_platform_id = selected_platforms[platforms_index_local].game_platform_id;
                                const default_index = this.arraySearch(platformsOptions, game_platform_id);
                                let default_value = {label: "Add a platform for this game."};
                                if (game_platform_id !== null) {
                                    default_value = platformsOptions[default_index];
                                }
                                const platforms_jsx = (
                                    <div className={classes.PlatformsBlock} key={game_platform_id}>
                                        <Select
                                            className={classes.PlatformsSelect}
                                            defaultValue={{
                                                value: selected_platforms[platforms_index_local].game_platform_id,
                                                label: default_value.label,
                                                isFixed: true,
                                                isDisabled: true
                                            }}
                                            options={platformsOptions}
                                            closeMenuOnSelect={true}
                                            onChange={(val) => {
                                                let platforms_local = [...selected_platforms];
                                                platforms_local[platforms_index_local] = {
                                                    game_platform_id: val.value
                                                };
                                                this.setState({selected_platforms: platforms_local});
                                                this.props.platformsUpdate(platforms_local);
                                            }}
                                        />
                                        <div className={classes.DeletePlatforms}>
                                            <Button className={classes.DeletePlatformsButton} size="sm" variant={"outline-danger"} onClick={() => {
                                                let filtered_array = selected_platforms.filter((value,index,array) => {
                                                    return index !== (platforms_index_local)
                                                });
                                                this.setState({selected_platforms: filtered_array});
                                                this.props.platformsUpdate(filtered_array);
                                            }}>X</Button>
                                        </div>
                                    </div>
                                );
                                platforms_index++;

                                return platforms_jsx;
                            })}
                        </dd>
                        <dt className="col-sm-3"> </dt>
                    </>
                );
            }
        }

        let new_game_platform_jsx = '';
        if (this.state.new_game_platform === true) {
            new_game_platform_jsx = (<NewPlatform
                game_platforms={this.state.platforms}
                newGamePlatformToggle={this.newGamePlatformToggle}
                onNewGamePlatform={this.newGamePlatformsHandler}
            />);
        }

        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Platforms</label></dt>
                {platforms_input_element}
                {new_game_platform_jsx}
                <dd className="col-sm-6"><Button className="col-sm-12" variant="outline-primary" onClick={this.addPlatform} disabled={this.state.new_game_platform}>Add Game Platform to Game</Button></dd>
                <dd className="col-sm-3"><Button className="col-sm-12" variant="outline-secondary" onClick={this.newGamePlatformToggle} disabled={this.state.new_game_platform}>Enter New Game Platform</Button></dd>
            </dl>
        );
    }
}

export default PlatformsInput;